module.exports = __webpack_public_path__ + "static/media/digital-work3.98ecf306.jpg";